import { lazy } from 'react';

const List = lazy(() => import('./list'));
const Details = lazy(() => import('./details'));

export { List, Details };
